import { combineReducers } from '@reduxjs/toolkit';

import { answersSlice } from './answers.slice';
import { questionAssignmentSlice } from './questionAssignment.slice';

export const questionSlice = combineReducers({
  questionAssignment: questionAssignmentSlice.reducer,
  answers: answersSlice.reducer,
});
